import { render, staticRenderFns } from "./rulersDetail.vue?vue&type=template&id=7ffec271&scoped=true&"
import script from "./rulersDetail.vue?vue&type=script&lang=js&"
export * from "./rulersDetail.vue?vue&type=script&lang=js&"
import style0 from "./rulersDetail.vue?vue&type=style&index=0&id=7ffec271&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffec271",
  null
  
)

export default component.exports